import { useState } from "react";

import CityFacilitiesNearYou from "@/src/modules/facilities/cityFacilitiesNearYou";

import CustomAccordion from "@/src/lib/ui/customAccordion";

export default function FacilitiesNearYou({ item, index }) {
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    return (
        <>
            <CustomAccordion
                title={item?.state}
                defaultExpanded={false}
                buttonClassName="rounded-none hover:bg-gray-100 font-bold md:text-xl text-base"
                className="border-b rounded-none"
                open={open}
                onClick={handleToggle}
            >
                <div className="grid gap-3 md:grid-cols-2 sm:grid-cols-2 lg:grid-cols-3">
                    {item?.cities?.map((row) => (
                        <CityFacilitiesNearYou key={row.city} row={row} />
                    ))}
                </div>
            </CustomAccordion>
        </>
    );
}
